import React from 'react';
import { useAuth } from '../AuthContext';


const CurrencyFormatter: React.FC<{ priceInCents: number }> = ({ priceInCents: value }) => {
    const { organizationInfo } = useAuth();

    const decimalPlaces = organizationInfo?.currencyDecimalPoint ?? 0;
    const divisor = Math.pow(10, decimalPlaces);
    const roundedValue = Number((value / divisor).toFixed(decimalPlaces));

    const formattedCurrency = `${organizationInfo?.currencySymbol}${roundedValue.toLocaleString(undefined, {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
    })}`;

    return <span>{formattedCurrency}</span>;
};

export default CurrencyFormatter;
